import { render, staticRenderFns } from "./a36.vue?vue&type=template&id=0a22ef88&scoped=true"
import script from "./a36.vue?vue&type=script&lang=js"
export * from "./a36.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a22ef88",
  null
  
)

export default component.exports